import { useState, useEffect } from 'react';
import { db } from './firebaseConfig';
import { doc, getDoc } from 'firebase/firestore';

const mapModelToDbName = (modelName) => {
  const modelDbNames = {
    'VorscineOne': 'vorscine-1',
    'VorscineTwo': 'vorscine-2',
    'Aequaliter': 'aequaliter',
    'MundiPretium': 'mundi-pretium',
    'NavisMagister': 'navis-magister'
  };
  return modelDbNames[modelName] || modelName;
};

export const useFetchProductData = (modelName, color) => {
  const [stock, setStock] = useState(null);
  const [price, setPrice] = useState(null);

  useEffect(() => {
    const fetchData = async () => {
      const dbModelName = mapModelToDbName(modelName);

      try {
        // Récupérer le stock
        const stockDocRef = doc(db, 'products', dbModelName, 'stocks', dbModelName);
        const stockDocSnap = await getDoc(stockDocRef);

        if (stockDocSnap.exists()) {
          const stockData = stockDocSnap.data();
          if (stockData && stockData[color]) {
            setStock(stockData[color]);
          } else {
            setStock(0);
          }
        } else {
          setStock(0);
        }

        // **Récupérer le prix**
        const priceDocRef = doc(db, 'products', dbModelName, 'price', dbModelName);

        const priceDocSnap = await getDoc(priceDocRef);

        if (priceDocSnap.exists()) {
          const priceData = priceDocSnap.data();

          if (priceData && priceData[color]) {
            setPrice(priceData[color]);
          } else {
            setPrice(null);
          }
        } else {
          setPrice(null);
        }

      } catch (error) {
      }
    };

    fetchData();
  }, [modelName, color]);

  return { stock, price };
};